import React from 'react';

const Label = ({
  htmlFor,
  children,
  className = '',
  'data-testid': dataTestId,
}) => {
  return (
    <label
      htmlFor={htmlFor}
      className={className}
      data-testid={dataTestId ?? (htmlFor ? `${htmlFor}-label` : undefined)}
    >
      {children}
    </label>
  );
};

export default Label;